import React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Avatar from '@mui/material/Avatar';
import headshot from '../images/headshot.jpeg';
import MotionW from '../images/motion-w.png';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import IconButton from '@mui/material/IconButton';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import siteUrls from '../config/siteUrls';

const styles = {
  headshot: {
    height: '50%',
    width: '50%',
    margin: 'auto',
    marginTop: '30px',
    marginBottom: '30px',
    border: '1px solid white',
    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
  },
  font: {
    fontFamily: 'EB Garamond, serif',
  },
  motionW: {
    marginRight: '15px',
    cursor: 'pointer',
  },
};

const openUrl = (url) => {
  window.open(url, '_blank');
};

export default function HomePage({ navigate }) {
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  const navigateToResume = () => {
    setIsDrawerOpen(false);
    navigate('/resume');
  };

  return (
    <>
      <IconButton
        aria-label='open navigation menu'
        color='inherit'
        onClick={() => setIsDrawerOpen(true)}
        sx={{ position: 'fixed', top: 16, right: 16 }}
      >
        <MenuIcon />
      </IconButton>
      <Drawer anchor='right' open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
        <Box sx={{ width: 240 }} role='presentation'>
          <List>
            <ListItemButton onClick={navigateToResume}>
              <ListItemText primary='Resume' />
            </ListItemButton>
          </List>
        </Box>
      </Drawer>

      <Container maxWidth='sm' sx={{ display: 'flex', flexDirection: 'column', margin: 'auto' }}>
        <Avatar src={headshot} alt='headshot' sx={styles.headshot} />
        <Typography component='h1' variant='h2' align='center' color='textPrimary' gutterBottom sx={styles.font}>
          Matt Austin
        </Typography>
        <Box display='flex' flexDirection='row' justifyContent='center' marginBottom={'1rem'}>
          <Link color='inherit' onClick={() => openUrl(siteUrls.uwEngineering)}>
            <Avatar src={MotionW} alt='motionW' variant='square' sx={styles.motionW} />
          </Link>
          <Typography variant='h6' align='center' color='textSecondary' paragraph sx={styles.font}>
            Software Engineer
          </Typography>
        </Box>
        <Grid container direction='row' justifyContent='center' alignItems='center' spacing='24'>
          <Grid item>
            <IconButton variant='contained' color='inherit' onClick={() => openUrl(siteUrls.linkedIn)}>
              <LinkedInIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton variant='outlined' color='inherit' onClick={() => openUrl(siteUrls.github)}>
              <GitHubIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton variant='contained' color='inherit' onClick={() => openUrl(siteUrls.instagram)}>
              <InstagramIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
